import { msg } from '@lingui/macro';

/**
 * New-model Sample-requests v2 prototype routes (DL-62519) — mock-only, on their
 * own `/sample-requests-v2` namespace. Detail is `:id` with an optional `:subtab`
 * segment (default tab at bare `/sample-requests-v2/:id`).
 */
export const SampleRequestsV2Routes = {
  path: 'sample-requests-v2',
  async lazy() {
    const { Parent } = await import('../pages/sample-requests-v2');
    return { Component: Parent };
  },
  handle: {
    name: 'Sample requests v2 list',
    category: 'Sample requests',
    title: msg`Sample requests (v2)`,
  },
  children: [
    {
      index: true,
      async lazy() {
        const { Index } = await import('../pages/sample-requests-v2');
        return { Component: Index };
      },
    },
    {
      path: ':id',
      async lazy() {
        const { Details } = await import('../pages/sample-requests-v2');
        return { Component: Details };
      },
      handle: { name: 'Sample request v2 details', category: 'Sample requests' },
    },
    {
      path: ':id/:subtab',
      async lazy() {
        const { Details } = await import('../pages/sample-requests-v2');
        return { Component: Details };
      },
      handle: { name: 'Sample request v2 details', category: 'Sample requests' },
    },
  ],
};
